import React, { useMemo, useState } from 'react';
import './OurPartners.css';

import logo1 from '../../img/world-bank.jpg';
import logo2 from '../../img/EU_lgflag.gif';
import logo3 from '../../img/200px-UNEP_logo.svg_.png';
import logo4 from '../../img/IFC.jpg';
import logo5 from '../../img/Logo_Bolloré_Transport_Logistics.png';
import logo6 from '../../img/RITES_logo.png';
import logo7 from '../../img/UNECA-transparent-500x250.png';
import logo8 from '../../img/af-logo.png';
import logo9 from '../../img/Screenshot-2019-04-27-070339.png';
import logo10 from '../../img/arton236.png';
import logo11 from '../../img/images.png';
import logo12 from '../../img/index1.jpeg';
import logo13 from '../../img/index2.png';
import logo14 from '../../img/index3.jpeg';
import logo15 from '../../img/index4.jpeg';
import rdbLogo from '../../img/rdb.png';

const RAW_PARTNERS = [
  { name: 'World Bank', logo: logo1, group: 'International', relationship: 'Partner' },
  { name: 'European Union', logo: logo2, group: 'International', relationship: 'Partner' },
  { name: 'UNEP', logo: logo3, group: 'International', relationship: 'Partner' },
  { name: 'IFC', logo: logo4, group: 'International', relationship: 'Partner' },
  { name: 'UNECA', logo: logo7, group: 'International', relationship: 'Partner' },
  { name: 'AF Switzerland', logo: logo8, group: 'International', relationship: 'Partner' },
  { name: 'CES', mark: 'CES', descriptor: 'Consulting Engineers', accent: '#b5252a', group: 'International', relationship: 'Partner' },
  { name: 'Studio Pietrangeli', mark: 'SP', descriptor: 'Engineering Consultancy', accent: '#17456f', group: 'International', relationship: 'Partner' },
  { name: 'SWECO', mark: 'SWECO', descriptor: 'Architecture & Engineering', accent: '#111111', group: 'International', relationship: 'Client & Partner' },

  { name: 'Rwanda Transport Development Agency', logo: logo9, group: 'Government & Agencies', relationship: 'Partner' },
  { name: 'Rwanda Resource Authority', logo: logo10, group: 'Government & Agencies', relationship: 'Partner' },
  { name: 'REMA', logo: logo12, group: 'Government & Agencies', relationship: 'Client & Partner' },
  { name: 'Rwanda Development Board', logo: rdbLogo, group: 'Government & Agencies', relationship: 'Client & Partner' },

  { name: 'Bolloré Transport & Logistics', logo: logo5, group: 'Private & Local', relationship: 'Partner' },
  { name: 'RITES', logo: logo6, group: 'Private & Local', relationship: 'Partner' },
  { name: 'Power China', logo: logo11, group: 'Private & Local', relationship: 'Partner' },
  { name: 'EAP', logo: logo13, group: 'Private & Local', relationship: 'Partner' },
  { name: 'RAPEP', logo: logo14, group: 'Private & Local', relationship: 'Partner' },
  { name: 'EDP', logo: logo15, group: 'Private & Local', relationship: 'Partner' },
  { name: 'Gasabo 3D', mark: 'G3D', descriptor: 'Design & Engineering', accent: '#ef7f1a', group: 'Private & Local', relationship: 'Partner' },
  { name: 'Eco Excellence', mark: 'eco', descriptor: 'Excellence Consultancy', accent: '#168b55', group: 'Private & Local', relationship: 'Partner' },
  { name: 'ATL', mark: 'ATL', descriptor: 'Rwanda', accent: '#0876a8', group: 'Private & Local', relationship: 'Client & Partner' },
];

const GROUPS = ['All', 'International', 'Government & Agencies', 'Private & Local'];

function OurPartners() {
  const [active, setActive] = useState('All');

  const partners = useMemo(() => {
    if (active === 'All') return RAW_PARTNERS;
    return RAW_PARTNERS.filter((p) => p.group === active);
  }, [active]);

  return (
    <div className="partners-page">
      <section className="partners-hero" role="region" aria-labelledby="partners-hero-heading">
        <div className="partners-hero-inner">
          <h1 id="partners-hero-heading" className="partners-title">Clients &amp; Partners</h1>
          <p className="partners-sub">
            We collaborate with clients and partners across global institutions, national agencies, and the private sector.
          </p>
        </div>
        <svg className="partners-wave" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0,80 C240,20 480,20 720,80 C960,140 1200,140 1440,80 L1440,120 L0,120 Z" />
        </svg>
      </section>

      {/* Segmented control (radio-like) */}
      <section className="partners-filters" aria-label="Filter partners by category">
        <div className="container">
          <div className="segmented" role="tablist" aria-label="Partner groups">
            {GROUPS.map((g) => (
              <button
                key={g}
                role="tab"
                aria-selected={active === g}
                className={`seg ${active === g ? 'is-active' : ''}`}
                onClick={() => setActive(g)}
              >
                {g}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="partners-grid-wrap">
        <div className="container">
          <div className="partners-grid" role="list">
            {partners.map((p) => (
              <article className="partner-card" key={p.name} role="listitem" aria-label={p.name}>
                <span className="partner-group" title={p.group}>
                  {p.group === 'Government & Agencies' ? 'Government' : p.group}
                </span>
                <span className={`partner-relationship ${p.relationship === 'Client & Partner' ? 'is-client' : ''}`}>
                  {p.relationship}
                </span>
                <div className="partner-frame">
                  {p.logo ? (
                    <img src={p.logo} alt={`${p.name} logo`} loading="lazy" />
                  ) : (
                    <div className="partner-wordmark" style={{ '--partner-accent': p.accent }} aria-hidden="true">
                      <strong>{p.mark}</strong>
                      <small>{p.descriptor}</small>
                    </div>
                  )}
                </div>
                <div className="partner-overlay">
                  <span className="partner-name">{p.name}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="partners-cta" role="region" aria-labelledby="partners-cta-heading">
        <div className="container">
          <h2 id="partners-cta-heading">Let’s grow together</h2>
          <p>Looking for a sustainable, policy-aligned partner? We’d love to collaborate.</p>
          <a className="partners-btn" href="/contact-us">Contact Us</a>
        </div>
      </section>
    </div>
  );
}

export default OurPartners;
